import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { PlatformLocation } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { PlanSlideComponent } from '../plan-slide/plan-slide.component';
import { HttpService } from 'src/services/http.service';
import { ErrorReportService } from 'src/services/error-report.service';
// const SLIDE_ITEMS = {
//   '(max-width: 599.99px) and (orientation: portrait)': 1,
//   '(max-width: 959.99px) and (orientation: landscape)': 2,
//   '(min-width: 600px) and (max-width: 839.99px) and (orientation: portrait)': 2,
//   '(min-width: 960px) and (max-width: 1279.99px) and (orientation: landscape)': 2
// };

@Component({
  selector: 'app-finish',
  templateUrl: './finish.component.html',
  styleUrls: ['./finish.component.scss']
})
export class FinishComponent implements OnInit {

  // plans: Array<any> = [
  //   {
  //     index: -1,
  //     code: 'MONTHLY',//mesmo que o plano anual, mas aparece como grátis para o usuário
  //     title: 'Plano Trimestral (comece grátis)',
  //     price: '0,00',
  //     period: 'trimestral',
  //     selected: false
  //   },
  //   {
  //     index: 0,
  //     code: 'YEARLY',
  //     title: 'Plano Anual',
  //     price: '49,90',
  //     period: 'anual',
  //     selected: false
  //   }    
  // ];
  // slideItemPage = 2;
  @Output() submit = new EventEmitter<boolean>();
  formPlan: FormGroup;
  mauticFormSrc: any = null;
  @ViewChild('PlanSlide', { static: false }) planSlide: PlanSlideComponent;

  constructor(
    fb: FormBuilder,
    private sanitazer: DomSanitizer,
    private pLocation: PlatformLocation,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpService,
    private errorReport: ErrorReportService,
  ) {

    this.formPlan = fb.group({
      email: [localStorage.getItem('email')],
      acceptTerm: [false, Validators.required],
      acceptSendMessage: [false],
      planSignature: [null],
      planCode: [null],
      acceptContract: [false, Validators.required],
    })

    this.route.queryParams.subscribe(
      query => {
        if (query.pi && query.valid && this.planSlide) {
          this.planSlide.selectPlanBy(query.pi);
        }
      }
    )

  }

  ngOnInit(): void {

  }

  choosePlan(plan) {

    this.formPlan.patchValue({
      planCode: plan.code,
      planSignature: plan.price,
      email: localStorage.getItem('email')
    })

    if (!this.formPlan.invalid) {

      const data = this.formPlan.getRawValue();

      const params = new URLSearchParams();

      for (let key in data) {
        const value = data[key];
        //if(value)
        params.append(key, value);
      }
      const hBase = this.pLocation.getBaseHrefFromDOM();

      this.mauticFormSrc = this.sanitazer
        .bypassSecurityTrustResourceUrl(`${hBase}mautic-form/finish?${params.toString()}`);

      plan.selected = true;
      // setTimeout(() => this.submit.emit(true), 1000);
    } else {
      this.submit.emit(false);
    }

  }

  doneAll() {
    if (!this.formPlan.invalid) {

      const data = {
        email: localStorage.getItem('email'),
        password: localStorage.getItem('password')
      }

      this.http.save('auth:login', data)
        .subscribe(
          (result: any) => {
            if (result.data) {
              localStorage.setItem('token', JSON.stringify(result.data));
              setTimeout(() => this.router.navigate(['/customer/welcome']), 250);
            }
          }
        )
    }
  }

}
